import { utf8OffsetToUtf16Index } from './utf8';

export type TextSelectionRange = {
    start: number;
    end: number;
};

/**
 * 规范化文本选区范围。
 *
 * 选区可能来自反向拖拽或 textarea 的反向选择，调用方传入的 `start` 可能大于 `end`。
 * 这里会把较小值作为 `start`、较大值作为 `end`，并把负数偏移钳制到 0。
 *
 * @param range - 需要规范化的文本选区范围。
 * @returns 规范化后的文本选区范围。
 */
export const normalizeSelectionRange = (range: TextSelectionRange): TextSelectionRange => ({
    start: Math.max(0, Math.min(range.start, range.end)),
    end: Math.max(0, Math.max(range.start, range.end)),
});

/**
 * 将 UTF-8 字节偏移选区转换为 JS 字符串切片使用的 UTF-16 索引。
 *
 * @param text - 选区所在的完整文本。
 * @param range - UTF-8 字节偏移表示的文本选区。
 * @returns 对应的 UTF-16 起止索引。
 */
export const rangeToUtf16 = (text: string, range: TextSelectionRange): [number, number] => {
    const sorted = normalizeSelectionRange(range);
    return [utf8OffsetToUtf16Index(text, sorted.start), utf8OffsetToUtf16Index(text, sorted.end)];
};
